module.exports = __webpack_public_path__ + "img/ver barras.29a6cb52.svg";